import { render, staticRenderFns } from "./ErrorWin.vue?vue&type=template&id=8f5235c6&scoped=true"
import script from "./ErrorWin.vue?vue&type=script&lang=js"
export * from "./ErrorWin.vue?vue&type=script&lang=js"
import style0 from "./ErrorWin.vue?vue&type=style&index=0&id=8f5235c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5235c6",
  null
  
)

export default component.exports